/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { MenuItem, MenuList, Popover} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TourIcon from '@mui/icons-material/esm/Slideshow';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
// import {intl} from '../../helper/IntlGlobalProvider';
import beginnerSteps from '../../tutorial/tour-beginner';
import appsSteps from '../../tutorial/tour-apps';
import appSteps from '../../tutorial/tour-app';
import createAppSteps from '../../tutorial/tour-createapp';

const TourButton = (props) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [popup, setPopup] = useState(false);

	const onShowPopup = (event) => {
		// This prevents ghost click.
		event.preventDefault();
		setAnchorEl(event.currentTarget);
		setPopup(true);
	};

	const onClosePopup = () => {
		setAnchorEl(null);
		setPopup(false);
	};

	return [
        <Tooltip key="tour-tool" enterDelay={300} title={<FormattedMessage id="Tooltip.StartTour" defaultMessage="Start Tour" />}>
			<div>
				<IconButton
					data-tour="button-tour"
					onClick={(event) => {
						onShowPopup(event, )
					}}
					size={props.appTour ? "small" : 'large'}
					sx={props.appTour ? {margin: '5px 0px 0px 4px', padding: '5px'} : undefined}
				>
					<TourIcon sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor})` }} />
				</IconButton>
			</div>

		</Tooltip>,
		<Popover
			key="popNumber"
			open={popup}
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
			transformOrigin={{ horizontal: 'left', vertical: 'top' }}
			onClose={onClosePopup}
		>
			<MenuList>
				<MenuItem
					key="tourbeginner"
					dense
					onClick={(event) => {
						onClosePopup();
						event.preventDefault();
						props.runTour(beginnerSteps);
					}}
				>
					<FormattedMessage id="Tour.Beginner" defaultMessage="Tour Beginner" />
				</MenuItem>
				<MenuItem
					key="tourapps"
					dense
					onClick={(event) => {
						onClosePopup();
						event.preventDefault();
						props.runTour(appsSteps);
					}}
				>
					<FormattedMessage id="Tour.Apps" defaultMessage="Tour Apps" />
				</MenuItem>
				{props.app ? [
					<MenuItem
						key="tourapp"
						dense
						onClick={(event) => {
							onClosePopup();
							event.preventDefault();
							props.runTour(appSteps);
						}}
					>
						<FormattedMessage id="Tour.App" defaultMessage="Tour App" />
					</MenuItem>,
					<MenuItem
						key="tourcreateapp"
						dense
						onClick={(event) => {
							onClosePopup();
							event.preventDefault();
							props.runTour(createAppSteps);
						}}
					>
						<FormattedMessage id="Tour.CreateApp" defaultMessage="Tour Create App" />
					</MenuItem>
				] : null
				}
			</MenuList>
		</Popover>
    ];
}

export default TourButton;
